import stylesUtils from "../styles/utils.module.scss";

/**
 * Trims first and last chars (e.g. double quotes) and adds parentheses
 * @param {String} mqCond For ex: "\"min-width:992px;\""
 * @returns {String}
 */
export const translateMediaQueryCond = (mqCond) => `(${mqCond.slice(1, -1)})`;

export const DESKTOP = "desktop";
export const MOBILE = "mobile";

/**
 * For usage with Pattern Library's use-media-query
 * Desktop only.
 * @returns {Object} queryObj - Object of key:value pairs where "key" is the name of the breakpoint and "value" is the media query string.
 */
export const desktopMediaQuery = {
  [DESKTOP]: translateMediaQueryCond(stylesUtils.desktopMq),
  [MOBILE]: ""
};
